import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const LessonViewerMainContainer = superstyled({
  tag: Grid,
  styles: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 1300,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%'
  }
});

export const LessonViewerHeaderContainer = superstyled({
  tag: Grid,
  styles: {
    padding: '0.75rem 0.5rem 0rem 0.5rem'
  }
});

export const LessonViewerProgressBarContainer = superstyled({
  tag: Grid,
  styles: ({ theme }) => ({
    padding: '0.75rem 1rem 0.5rem 1rem',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: '2rem'
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: '4rem'
    }
  })
});

export const LessonViewerCompletionContainer = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1300,
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: theme.palette.growth50.main
  })
});

export const LessonViewerContentContainer = superstyled({
  tag: Grid,
  styles: {
    height: '100%',
    maxHeight: 'fit-content'
  }
});

export const StickyHeader = superstyled({
  tag: Grid,
  styles: {
    backgroundColor: 'white',
    position: 'sticky',
    zIndex: 10,
    top: '0'
  }
});
